import { IntegrationInstance } from 'models'

/* Narrows a candidate source list to the instances the platform says can feed the CPI, matching on
 * instance name — the key the v2 activation payload sends. `compatibleInstanceNames` of null means
 * no answer applies (legacy CPIs), so the list passes through; an empty answer drops everything,
 * which is how a failed lookup fails closed. Instances already linked to the CPI always survive:
 * the answer gates candidates, not history. */
export const filterToCompatibleSources = (
  candidates: IntegrationInstance[],
  compatibleInstanceNames: string[] | null,
  linkedInstanceIds: string[] = []
): IntegrationInstance[] => {
  if (compatibleInstanceNames === null) return candidates

  const compatible = new Set(compatibleInstanceNames.filter(Boolean))
  const linked = new Set(linkedInstanceIds.filter(Boolean))

  return candidates.filter(
    (candidate) => (candidate.instance_name && compatible.has(candidate.instance_name)) || linked.has(candidate.id)
  )
}
